import { createAction, props } from '@ngrx/store';

export const title = createAction('[Panel] Title', props<{ id: string, title: string }>());
export const collapse = createAction('[Panel] Collapse', props<{ payload: string }>());
export const maximize = createAction('[Panel] Maximize', props<{ payload: string }>());
export const restore = createAction('[Panel] Restore', props<{ payload: string }>());
